import { render, staticRenderFns } from "./BidsEdit.vue?vue&type=template&id=7bcd260a"
import script from "./BidsEdit.vue?vue&type=script&lang=js"
export * from "./BidsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports